import React from "react";

const EtTrinityReflectEnergy = ({ userId, onClose }) => {

  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Purpose - Encourage user to reflect on energy highs and lows

  return (
    <div className="p-4">
      <h3 className="text-lg font-bold text-gray-800 mb-2">Reflect on Energy</h3>
      <p className="text-sm text-gray-600 mb-2">[Ask: What energized you most today? What drained your energy?]</p>
      <button onClick={onClose} className="mt-4 text-sm text-blue-600 underline">Close</button>
    </div>
  );
};

export default EtTrinityReflectEnergy;